module.exports = {
      id: "rte:italics-usage",
      viewBox: "0 0 320 512",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#rte:italics-usage",
      toString: function () {
        return this.url;
      }
    }